"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthMock = exports.Mapper = void 0;
const EAppType_1 = require("../domain/EAppType");
class Mapper {
}
exports.Mapper = Mapper;
exports.AuthMock = {
    userId: "mock-user",
    appType: EAppType_1.EAppType.V.TESTING,
};
//# sourceMappingURL=Mapper.js.map